import { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Account } from "./components/Account";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState<typeof JsonData | null>(null);
  const [currentPage, setCurrentPage] = useState("home");

  useEffect(() => {
    setLandingPageData(JsonData);

    // Check URL hash on load
    const hash = window.location.hash.replace("#", "");
    if (hash === "account") {
      setCurrentPage("account");
    }

    // Listen for hash changes
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#", "");
      if (hash === "account") {
        setCurrentPage("account");
      } else if (hash === "" || hash === "page-top") {
        setCurrentPage("home");
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const handleNavigate = (page: string) => {
    setCurrentPage(page);
    window.location.hash = page;
    window.scrollTo(0, 0);
  };

  return (
    <div className="App">
      <Navigation onNavigate={handleNavigate} />
      {currentPage === "account" ? (
        <Account />
      ) : landingPageData ? (
        <>
          <Header data={landingPageData.Header} />
          <Features data={landingPageData.Features} />
          <About data={landingPageData.About} />
        </>
      ) : null}
    </div>
  );
};

export default App;
